import { Box, LinearProgress } from '@mui/material';
import { ListItem } from 'hooks/useMuiTableBuilderV2';

export type LoaderCellData = ListItem;

export const LoaderCell = () => {
  return (
    <Box textAlign={'left'}>
      <LinearProgress />
    </Box>
  );
};
